const topMenuData = {
    top: [
        {
            type: 'LogoLink',
            href: 'https://nandos.co.uk',
            className: 'logo',
            text: 'Nando’s'
        },
        {
            type: 'List',
            className: 'menu-top',
            hideFromMobile: true,
            children: [
                {
                    text: 'Log in',
                    className: 'lbutton',
                    href: 'https://www.nandos.co.uk/card/auth/login',
                    type: 'Link'
                },
                {
                    text: 'Sign up',
                    className: 'lbutton',
                    href: 'https://www.nandos.co.uk/card/auth/register',
                    type: 'Link'
                },
                {
                    text: 'Menu',
                    href: 'https://www.nandos.co.uk/food/menu',
                    type: 'Link'
                },
                {
                    text: 'Restaurants',
                    type: 'Link',
                    children: [
                        {
                            text: 'To find a Nando’s enter a town or postcode',
                            type: 'RestaurantLocator',
                            className: 'shorten',
                            market: 'UK'
                        },
                        {
                            type: 'Divider'
                        },
                        {
                            text: 'View All Restaurants',
                            href: 'https://www.nandos.co.uk/restaurants',
                            type: 'Link'
                        }
                    ]
                },
                {
                    type: 'Link',
                    text: 'Nando’s Rewards',
                    children: [
                        {
                            text: 'Join now',
                            href: 'https://www.nandos.co.uk/card/auth/register',
                            type: 'Link'
                        },
                        {
                            text: 'How it works',
                            href: 'https://www.nandos.co.uk/card/about',
                            type: 'Link'
                        },
                        {
                            text: 'Lost Card',
                            href: 'https://www.nandos.co.uk/card/lost-your-card',
                            type: 'Link'
                        },
                        {
                            type: 'Divider'
                        },
                        {
                            text: 'Log In',
                            href: 'https://www.nandos.co.uk/card/auth/login',
                            type: 'Link',
                            target: '_blank',
                            className: 'login'
                        }
                    ]
                },
                {
                    type: 'Link',
                    text: 'Cook',
                    children: [
                        {
                            text: 'Products',
                            href: 'https://www.nandos.co.uk/food/products',
                            type: 'Link'
                        },
                        {
                            text: 'Recipes',
                            href: 'https://www.nandos.co.uk/food/recipes',
                            type: 'Link'
                        }
                    ]
                },
                {
                    text: 'Shop',
                    href: 'https://www.nandos.co.uk/food/shop',
                    type: 'Link'
                },
                {
                    text: 'About Us',
                    className: 'explore',
                    type: 'Link',
                    children: [
                        {
                            text: 'About',
                            type: 'Title'
                        },
                        {
                            text: 'Food',
                            href: 'https://www.nandos.co.uk/about-us/food',
                            type: 'Link'
                        },
                        {
                            text: 'What’s New',
                            href: 'https://www.nandos.co.uk/food/whats-new',
                            type: 'Link'
                        },
                        {
                            text: 'Fighting Malaria',
                            href: 'https://www.nandos.co.uk/explore/fightingmalaria',
                            type: 'Link'
                        },
                        {
                            text: 'Being Sustainable',
                            href: 'https://www.nandos.co.uk/explore/being-sustainable',
                            type: 'Link'
                        },
                        {
                            text: 'Connect',
                            type: 'Title'
                        },
                        {
                            text: 'The Nando’s App',
                            href: 'https://www.nandos.co.uk/explore/app',
                            type: 'Link'
                        },
                        {
                            text: 'News',
                            href: 'https://www.nandos.co.uk/explore/blog',
                            type: 'Link'
                        },
                        {
                            text: 'Experience',
                            type: 'Title'
                        },
                        {
                            text: 'This is PERi-PERi',
                            href: 'https://www.nandos.co.uk/explore/this-is-peri-peri',
                            type: 'Link'
                        },
                        {
                            text: 'Music',
                            href: 'https://www.nandos.co.uk/explore/music',
                            type: 'Link'
                        },
                        {
                            text: 'Art',
                            href: 'https://www.nandos.co.uk/explore/art',
                            type: 'Link'
                        }
                    ]
                },
                {
                    type: 'Link',
                    text: 'Help',
                    children: [
                        {
                            type: 'Title',
                            text: 'FAQs'
                        },
                        {
                            text: 'Search FAQs',
                            href: 'https://help.nandos.co.uk/hc/en-gb',
                            type: 'Link'
                        },
                        {
                            text: 'My Account',
                            href: 'https://www.nandos.co.uk/help/my-account',
                            type: 'Link'
                        },
                        {
                            text: 'Food',
                            href: 'https://www.nandos.co.uk/help/our-food',
                            type: 'Link'
                        },
                        {
                            text: 'Online Ordering',
                            href: 'https://www.nandos.co.uk/help/online-ordering',
                            type: 'Link'
                        },
                        {
                            text: 'Restaurants',
                            href: 'https://www.nandos.co.uk/help/our-restaurants',
                            type: 'Link'
                        },
                        {
                            text: 'Nando’s Card & Discounts',
                            href: 'https://www.nandos.co.uk/help/nandos-cards-gift-cards-discounts',
                            type: 'Link'
                        },
                        {
                            text: 'Fundraising Requests',
                            href: 'https://help.nandos.co.uk/hc/en-gb/articles/360016324818-I-Am-Organising-A-Fundraising-Event-Can-You-Help-',
                            type: 'Link'
                        },
                        {
                            text: 'Sustainability',
                            href: 'https://www.nandos.co.uk/help/sustainability',
                            type: 'Link'
                        },
                        {
                            text: 'Contact',
                            type: 'Title'
                        },
                        {
                            text: 'Contact Us',
                            href: 'https//www.nandos.co.uk/help/contact',
                            type: 'Link'
                        },
                        {
                            text: 'Resources',
                            type: 'Title'
                        },
                        {
                            text: 'Press Gallery',
                            href: 'https://www.nandos.co.uk/press-gallery',
                            type: 'Link'
                        }
                    ]
                },
                {
                    type: 'Divider'
                },
                {
                    text: 'Careers',
                    type: 'Link',
                    href: 'https://nandos.careers/',
                    className: 'careers'
                }
            ]
        },
        {
            type: 'List',
            className: 'endgroup',
            children: [
                {
                    title: 'Nando’s Profile',
                    type: 'Link',
                    className: 'login',
                    target: '_blank',
                    href: 'https://www.nandos.co.uk/profile',
                    text: 'Profile'
                },
                {
                    title: 'Ordering online',
                    className: 'order',
                    type: 'Link',
                    href: 'https://www.nandos.co.uk/order/search',
                    text: 'Order online'
                },
                {
                    type: 'MobileNavigation',
                    className: 'mobileOpener'
                }
            ]
        }
    ]
};

export { topMenuData };
